var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.71 5.15L18.86 2.31C18.6722 2.12068 18.4166 2.0142 18.15 2.0142C17.8834 2.0142 17.6278 2.12068 17.44 2.31L15.32 4.42L19.59 8.69L21.67 6.61C21.8772 6.42652 21.9992 6.16535 22.0067 5.88867C22.0143 5.61199 21.9069 5.34455 21.71 5.15ZM3.08001 16.66L2.00001 20.73C1.8739 21.0934 1.96737 21.4968 2.2404 21.7678C2.51344 22.0387 2.91765 22.129 3.28001 22L7.35001 21L18.18 10.11L13.91 5.84L3.08001 16.66Z",
    fill: "#3E454E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDark);
export default __webpack_public_path__ + "static/media/edit-dark.eda250e6ff57cc0bef70d982b9833a27.svg";
export { ForwardRef as ReactComponent };